<template>
  <div class="navbar">
    <div class="nav-open" v-if="showNav">
      <div class="nav-id">
        <img src="../assets/img/navbar/avatar.png" alt="">
        <span class="nav-greeting">Hello <strong>{{ user.displayName }}!</strong></span>
      </div>
      <nav class="nav-menu">
        <router-link :to="{ name: 'Home' }"><span><i class="fas fa-home"></i></span>Home</router-link>
        <router-link :to="{ name: 'Dashboard' }"><span><i class="fas fa-layer-group"></i></span>Dashboard</router-link>
        <router-link :to="{ name: 'Bookmarks' }"><span><i class="fas fa-bookmark"></i></span>Bookmarks</router-link>
      </nav>
      <div class="nav-actions">
        <button @click="handleClick">Logout</button>
        <button @click="showNav = !showNav"><span><i class="fas fa-eye-slash"></i></span></button>
      </div>
    </div>
    <div class="nav-closed" v-else>
      <div>
        <button @click="showNav = !showNav"><span><i class="fas fa-eye"></i></span></button>
      </div>
    </div>
  </div>
</template>

<script>
import useLogout from '@/composables/useLogout'
import getUser from '@/composables/getUser'
import { useRouter } from 'vue-router'
import { ref } from 'vue'

export default {
  setup() {
    const router = useRouter()
    const { logout } = useLogout()
    const { user } = getUser()

    const showNav = ref(false)

    const handleClick = async () => {
      await logout()
      // console.log('user logged out')
      router.push({ name: 'Welcome' })
    }

    return { handleClick, user, showNav }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/partials/_global.scss';

.navbar {
  position: relative;
  color: $txt-lite;
  z-index: 10000;
}
a,
button {
  display: inline-block;
  line-height: 1;
  text-align: center;
  color: $light;
  background-color: rgba($black, 0.8);
  border-radius: $brad;
  &:hover {
    background-color: rgba($black, 1);
  }
}
button {
  font-size: 1.4rem;
  padding: 10px 12px;
  box-shadow: 2px 2px 2px rgba($black, 0.4);
  &:active {
    box-shadow: 1px 1px 2px rgba($black, 0.7);
  }
}
a {
  font-size: 1.2rem;
  width: 32%;
  padding: 16px 14px;
  span {
    display: inline-block;
    font-size: 3.2rem;
    width: 100%;
    margin-bottom: 6px;
  }
  &:hover {
    background-color: rgba($black, 1);
  }
}
a.router-link-active {
  color: $comp-lite;
}

div.nav-open {
  padding: 10px 18px;
  background: rgba($shdw, 1);
  display: flex;
  justify-content: space-between;
  flex-direction: column-reverse;
  .nav-id {
    color: $light;
    display: block;
    position: absolute;
    top: 10px;
    left: 4%;
    img {
      float: left;
      width: 36px;
      height: 36px;
      margin-right: 10px;
    }
    span {
      display: inline-block;
      margin-top: 6px;
      font-size: 2rem;
      strong {
        font-family: 'black';
      }
    }
  }
  .nav-menu {
    display: flex;
    justify-content: space-between;
    margin: 20px 0 6px;
  }
  .nav-actions {
    text-align: right;
    margin-top: 2px;
    button {
      margin-left: 8px;
    }
  }
}
div.nav-closed {
  padding: 10px 18px;
  position: fixed;
  right: 0;
  top: 2px;
}

@media screen and (min-width: 720px) {
  div.nav-open {
    flex-direction: row;
    .nav-id {
      position: relative;
      top: 0;
      left: 0;
    }
    .nav-menu {
      margin: 2px 0 4px;
    }
  }
  a {
    width: auto;
    font-size: 1.4rem;
    padding: 10px 12px;
    margin: 1px 0 0 8px;
    span {
      font-size: 1.4rem;
      display: inline;
      width: auto;
      margin: 0 10px 0 0;
    }
    &:hover {
      background-color: rgba($black, 1);
    }
  }
}
</style>